import { BCMSRecord, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import PageContainer from 'components/shared/containers/PageContainer';
import { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import ContentSubheaderView from 'components/shared/views/ContentSubheaderView';
import PageContentView from 'components/shared/views/PageContentView';
import ProfilePicker from 'components/shared/widgets/ProfilePicker';
import Classes, { Profile } from "model";
import React from 'react';
import "./styles.css";
import "./mobile.css";

/**
 * @function PaymentsPage
 * @return {React.Component}
 * @note - Branding for this page is being added to the window object so captures can utilize the set value in state code
 * @exported true
 * @description The main component for PaymentsPage  
 */
export default function PaymentsPage(props) {
  // Branding options needed for captures
  const options = useModel().branding.options;
  let model = useModel();
  window.BRANDING = { "rxp17_abi22" : options.rxp17_abi22 };
  const label = options.payments_label_abi22 ?? "Payments";
  const paymentDemo = model.demos.RXP17 ? "RXP17": "RXP22"; 
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);
  const profiles = Profile.initAll(); 
  const subheaderText = options.payments_subheader_abi22;
  const hasSubheaderText = subheaderText ? true : false;

  return (
    <PageContainer className="payments-page integrated-product-page" ignoreTrigger={ true }>
      <PageContentView>
      { options.multiprofile_abi22 === "true" &&
          <ProfilePicker profiles = {profiles} ui={{}} onChange = {()=>{}} onSelectClick={()=>{}} disableBusiness="true"/>
      }           
        <CenterContentContainer>
          <ContentHeaderView text={label}/>
          { hasSubheaderText && <ContentSubheaderView text={ subheaderText } /> }
          <div className="iframe-container flex-container flex-horizontal justify-center">
                  
            {/* iFrame for RXP17 goes here */}
            <ExternalIframe className="payments-iframe" demo={paymentDemo} key="PaymentsPage"/>
          </div>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  );
}
